<template>
  <iDatePicker
    v-model="value"
    :width="getOptionValue(LayoutWidth)"
    :label="labelValue"
    :placeholder="placeholderValue"
    :style-overrides="inputStyleOverrides"
  />
</template>

<script>
import { plainLabelText } from "%/dynamic-component-editor/helpers/plain-label-text.mjs";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import DynamicAppInputOptionsMixin from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/inputs/dynamic-app-input-options-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import Label from "%/dynamic-component-editor/options/label";
import Placeholder from "%/dynamic-component-editor/options/placeholder";
import TimestampEmptyValue from "%/dynamic-component-editor/options/timestamp-empty-value";

import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderWidth from "%/dynamic-component-editor/options/border-width";

export default {
  name: "DynamicAppDateInputElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext, DynamicAppInputOptionsMixin],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  hidden: true,
  options: [
    Label,
    Placeholder,
    TimestampEmptyValue,
    BackgroundColor,
    BorderColor,
    BorderWidth,
  ],
  optionBundles: [
    new BasicTextOptions({}, {
      "font-family": true,
    }),
    new LayoutWidthHeightOptions({}, {
      "max-width": true,
      "max-height": true,
      "min-width": true,
      "min-height": true,
    }),
    new SpacingOptions(),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
  computed: {
    LayoutWidth() {
      return LayoutWidth;
    },
    labelValue() {
      return plainLabelText(this.getOptionValue(Label));
    },
    placeholderValue() {
      return this.appInputResolvedValue(this.getOptionValue(Placeholder)) ?? "";
    },
    emptyValue() {
      const declared = Number(this.appInputResolvedValue(this.getOptionValue(TimestampEmptyValue)));
      return Number.isFinite(declared) && declared >= 0 ? declared : null;
    },
    // iDatePicker paints its field through `input*` keys and its shell
    // spacing through `container*` keys.
    inputStyleOverrides() {
      const padding = this.appInputPadding;
      const margins = this.appInputMargins;
      return this.appInputStyleOverrides({
        borderRadius: this.appInputBorderRadius,
        inputBorderColor: this.appInputBorderColor,
        inputBorderWidth: this.appInputBorderWidth,
        inputFontSize: this.appInputFontSize,
        inputPaddingTop: padding.top ?? null,
        inputPaddingBottom: padding.bottom ?? null,
        inputPaddingLeft: padding.left ?? null,
        inputPaddingRight: padding.right ?? null,
        containerMarginTop: margins.marginTop ?? null,
        containerMarginBottom: margins.marginBottom ?? null,
        containerMarginLeft: margins.marginLeft ?? null,
        containerMarginRight: margins.marginRight ?? null,
      });
    },
    value: {
      get() {
        const stored = this.valueFromContext;
        if (this.emptyValue !== null && Number(stored) === this.emptyValue) {
          return "";
        }
        return stored;
      },
      set(value) {
        if (this.editMode) {
          return;
        }
        if (value === "" || value === null) {
          this.valueFromContext = this.emptyValue ?? value;
          return;
        }
        this.valueFromContext = value;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
